var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" />
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ObjectQueryStatusType = /** @class */ (function () {
            function ObjectQueryStatusType() {
            }
            return ObjectQueryStatusType;
        }());
        services.ObjectQueryStatusType = ObjectQueryStatusType;
        var ObjectQueryStateType = /** @class */ (function () {
            function ObjectQueryStateType() {
            }
            return ObjectQueryStateType;
        }());
        services.ObjectQueryStateType = ObjectQueryStateType;
        var ObjectQueryProcessType = /** @class */ (function () {
            function ObjectQueryProcessType() {
            }
            return ObjectQueryProcessType;
        }());
        services.ObjectQueryProcessType = ObjectQueryProcessType;
        var ObjectQueryProcessSubType = /** @class */ (function () {
            function ObjectQueryProcessSubType() {
            }
            return ObjectQueryProcessSubType;
        }());
        services.ObjectQueryProcessSubType = ObjectQueryProcessSubType;
        var ObjectQueryReviewConfiguration = /** @class */ (function () {
            function ObjectQueryReviewConfiguration() {
            }
            return ObjectQueryReviewConfiguration;
        }());
        services.ObjectQueryReviewConfiguration = ObjectQueryReviewConfiguration;
        var ObjectQueryApiAction = /** @class */ (function () {
            function ObjectQueryApiAction() {
            }
            return ObjectQueryApiAction;
        }());
        services.ObjectQueryApiAction = ObjectQueryApiAction;
        var ObjectQueryReviewType = /** @class */ (function () {
            function ObjectQueryReviewType() {
            }
            return ObjectQueryReviewType;
        }());
        services.ObjectQueryReviewType = ObjectQueryReviewType;
        var ObjectQueryAssignmentClaim = /** @class */ (function () {
            function ObjectQueryAssignmentClaim() {
            }
            return ObjectQueryAssignmentClaim;
        }());
        services.ObjectQueryAssignmentClaim = ObjectQueryAssignmentClaim;
        var ObjectQueryStringTuple = /** @class */ (function () {
            function ObjectQueryStringTuple(name, value) {
                this.name = name;
                this.value = value;
            }
            return ObjectQueryStringTuple;
        }());
        services.ObjectQueryStringTuple = ObjectQueryStringTuple;
        var ObjectQueryFormApiQuery = /** @class */ (function () {
            function ObjectQueryFormApiQuery() {
            }
            return ObjectQueryFormApiQuery;
        }());
        services.ObjectQueryFormApiQuery = ObjectQueryFormApiQuery;
        var ObjectQueryFormApiForm = /** @class */ (function () {
            function ObjectQueryFormApiForm() {
            }
            return ObjectQueryFormApiForm;
        }());
        services.ObjectQueryFormApiForm = ObjectQueryFormApiForm;
        var ObjectQueryGroupSetting = /** @class */ (function () {
            function ObjectQueryGroupSetting() {
            }
            return ObjectQueryGroupSetting;
        }());
        services.ObjectQueryGroupSetting = ObjectQueryGroupSetting;
        var ObjectQueryApiSchemaProperty = /** @class */ (function () {
            function ObjectQueryApiSchemaProperty() {
            }
            return ObjectQueryApiSchemaProperty;
        }());
        services.ObjectQueryApiSchemaProperty = ObjectQueryApiSchemaProperty;
        var ObjectQueryService = /** @class */ (function (_super) {
            __extends(ObjectQueryService, _super);
            function ObjectQueryService(injectedBreeze, $q, $http, extensibilityService, deleteService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.extensibilityService = extensibilityService;
                _this.deleteService = deleteService;
                var self = _this;
                self.qService = $q;
                self.subscribeHasChanges(function () {
                    var changes = warsBreeze.entityManager.getChanges();
                    for (var i = 0; i < changes.length; i++) {
                        var oqId;
                        var oq;
                        var entityName = changes[i].entityAspect.entity.entityType.shortName;
                        if (entityName === "ObjectQuery") {
                            oq = changes[i];
                        }
                        else if (entityName === "ObjectQueryProjection") {
                            if (changes[i].entityAspect.entityState.isModified()) {
                                if (changes[i].entityAspect.originalValues.propertyType !== undefined ||
                                    changes[i].entityAspect.originalValues.projectionType !== undefined) {
                                    changes[i].alias = "";
                                }
                            }
                            oqId = changes[i].objectQuery_id;
                        }
                        else if (entityName === "ObjectQueryPredicate") {
                            oqId = changes[i].objectQuery_id;
                        }
                        else if (entityName === "ObjectQueryConjunction") {
                            oqId = changes[i].objectQuery_id;
                        }
                        else if (entityName === "ObjectQueryDisjunction") {
                            oqId = changes[i].objectQuery_id;
                        }
                        if (oq != null) {
                            self.onObjectQueryModified(oq);
                        }
                        else if (oqId != null) {
                            //get entity from cache
                            self.fetchById(oqId, "ObjectQuery")
                                .then(function (result) {
                                if (result != null) {
                                    self.onObjectQueryModified(result);
                                }
                            });
                        }
                    }
                });
                return _this;
            }
            ObjectQueryService.prototype.getObjectQueryFormApiForms = function (processConfigurationId) {
                var self = this;
                var d = self.qService.defer();
                self.$http.get("api/ObjectQuery/ObjectQueryFormApiList?processConfigurationId=" + processConfigurationId).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.getObjectQueryFormApiQueries = function (processConfigurationId) {
                var self = this;
                var d = self.qService.defer();
                self.$http.get("api/ObjectQuery/ProcessQueryList?processConfigurationId=" + processConfigurationId).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.getQueryApi = function (processConfigurationId) {
                var self = this;
                var d = self.qService.defer();
                self.$http.get("api/ObjectQuery/ObjectQueryFormApi?processConfigurationId=" + processConfigurationId).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.saveQueryApi = function (api) {
                var self = this;
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/ObjectQueryFormApi", api).then(function () {
                    d.resolve();
                });
                return d.promise;
            };
            ObjectQueryService.prototype.removeQueryApi = function (api) {
                var self = this;
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/RemoveObjectQueryFormApi", api).then(function () {
                    d.resolve();
                });
                return d.promise;
            };
            ObjectQueryService.prototype.addQueryResultMapping = function (api, mapSet) {
                var self = this;
                var d = self.qService.defer();
                var pack = {
                    api: api,
                    mapSet: mapSet
                };
                self.$http.post("api/ObjectQuery/AddQueryResultMapping", pack).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.removeResultMapping = function (mapping, mapSet) {
                var self = this;
                var d = self.qService.defer();
                var pack = {
                    mapping: mapping,
                    mapSet: mapSet
                };
                self.$http.post("api/ObjectQuery/RemoveQueryResultMapping", pack).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.reorderResultMapping = function (mapping, ascending, mapSet) {
                var self = this;
                var payload = {
                    property: mapping,
                    ascending: ascending,
                    mapSet: mapSet
                };
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/ReorderQueryResultMapping", payload).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.updateMapSetOrder = function (mapSet, ascending) {
                var self = this;
                var payload = {
                    ascending: ascending,
                    mapSet: mapSet
                };
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/ReorderQueryResultMapSet", payload).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.saveResultMapping = function (mapping) {
                var self = this;
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/SaveQueryResultMapping", mapping).then(function () {
                    d.resolve();
                });
                return d.promise;
            };
            ObjectQueryService.prototype.saveMapSet = function (mapSet) {
                var self = this;
                var d = self.qService.defer();
                self.$http.post("api/ObjectQuery/SaveQueryResultMapSet", mapSet).then(function () {
                    d.resolve();
                });
                return d.promise;
            };
            ObjectQueryService.prototype.testExecution = function (objectQuery) {
                var self = this;
                var d = self.qService.defer();
                self.$http.get("api/ObjectQuery/TestExecution?objectQueryId=" + objectQuery.id).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.getGroupSettings = function (processConfigId, formUniqueIdentifier) {
                var self = this;
                var d = self.qService.defer();
                self.$http.get("api/ObjectQuery/FormGroupSettings?processConfigId=" + processConfigId + "&formUniqueIdentifier=" + formUniqueIdentifier).then(function (results) {
                    d.resolve(results.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.executeForm = function (processTypeId, formUniqueIdentifier, processId, groupSettings) {
                var self = this;
                var d = self.qService.defer();
                if (groupSettings != null && groupSettings.length > 0) {
                    groupSettings = Enumerable.from(groupSettings).orderBy(function (i) { return i.order; }).toArray();
                }
                self.$http.post("api/ObjectQuery/ExecuteForm", {
                    processTypeId: processTypeId,
                    formUniqueIdentifier: formUniqueIdentifier,
                    processId: processId,
                    groupSettings: groupSettings
                })
                    .then(function (results) {
                    d.resolve(results.data);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.removeSubQuery = function (objectQueryId) {
                var self = this;
                for (var i = 0; i < self.subQueries.length; i++) {
                    if (self.subQueries[i].id === objectQueryId) {
                        self.subQueries.splice(i, 1);
                        break;
                    }
                }
            };
            ObjectQueryService.prototype.removeProcessIdSubQuery = function (objectQueryId) {
                var self = this;
                for (var i = 0; i < self.processIdSubQueries.length; i++) {
                    if (self.processIdSubQueries[i].id === objectQueryId) {
                        self.processIdSubQueries.splice(i, 1);
                        break;
                    }
                }
            };
            ObjectQueryService.prototype.deleteObjectSchema = function (objectSchema) {
                var self = this;
                var d = self.qService.defer();
                self.deleteService.deleteRecursivelyWithoutWarning("ObjectSchema", objectSchema.id, true).then(function (result) {
                    d.resolve();
                });
                return d.promise;
            };
            ObjectQueryService.prototype.onObjectQueryModified = function (objectQuery) {
                var self = this;
                //pre-delete and executable status save
                objectQuery.isExecutable = false;
                //remove from subqueries
                self.removeSubQuery(objectQuery.id);
                self.removeProcessIdSubQuery(objectQuery.id);
            };
            ObjectQueryService.prototype.deleteObjectQuery = function (objectQuery) {
                var self = this;
                var d = self.qService.defer();
                self.deleteService.deleteWithModalConfirmationIfNecessary("ObjectQuery", objectQuery.id, null, function () {
                    d.resolve(null);
                }, null, function (result) {
                    d.reject(result);
                });
                return d.promise;
            };
            ObjectQueryService.prototype.createNewObjectQuery = function () {
                var q = this.createNewEntity("ObjectQuery", {});
                q.canAddProjection = true;
                return q;
            };
            ObjectQueryService.prototype.isAggregateQuery = function (objectQuery) {
                if (objectQuery.isAggregateQuery != null) {
                    return objectQuery.isAggregateQuery;
                }
                if (objectQuery.projections.length > 0) {
                    if (Enumerable.from(objectQuery.projections).all(function (i) { return i.projectionType === 0 /* Property */; })) {
                        objectQuery.isAggregateQuery = false;
                    }
                    else {
                        objectQuery.isAggregateQuery = true;
                    }
                }
                return objectQuery.isAggregateQuery;
            };
            ObjectQueryService.prototype.createNewObjectQueryProjection = function (objectQuery, isProcessLevel) {
                var projection = this.createNewEntity("ObjectQueryProjection", {});
                projection.myObjectQuery = objectQuery;
                projection.objectQuery_id = objectQuery.id;
                projection.descending = false;
                if (this.isAggregateQuery(objectQuery)) {
                    projection.projectionTypeContext.removeSpecifiedOptions = [];
                    projection.projectionTypeContext.removeSpecifiedOptions.push(0 /* Property */);
                    projection.projectionType = 6 /* Group */;
                    var hasAggregaate = Enumerable.from(objectQuery.projections).any(function (i) { return i.projectionType !== 6 /* Group */; });
                    if (hasAggregaate) {
                        projection.projectionTypeContext.removeSpecifiedOptions.push(1 /* Count */);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(4 /* Max */);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(3 /* Min */);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(2 /* Sum */);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(5 /* Avg */);
                    }
                }
                else {
                    projection.projectionTypeContext.removeSpecifiedOptions = [];
                    projection.projectionTypeContext.removeSpecifiedOptions.push(6 /* Group */);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(1 /* Count */);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(4 /* Max */);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(3 /* Min */);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(2 /* Sum */);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(5 /* Avg */);
                    projection.projectionType = 0 /* Property */;
                }
                projection.propertyType = 0 /* Property */;
                if (objectQuery.projections.length === 0) {
                    projection.orderNumerator = 1;
                }
                else {
                    var l = Enumerable
                        .from(objectQuery.projections)
                        .orderByDescending(function (i) { return i.orderNumerator; })
                        .toArray();
                    projection.orderNumerator = l[0].orderNumerator + 1;
                }
                projection.propertyTypeContext.removeSpecifiedOptions = [];
                if (isProcessLevel) {
                    projection.propertyTypeContext.removeSpecifiedOptions.push(4 /* ProcessType */);
                }
                if (this.getStates().length === 0) {
                    projection
                        .propertyTypeContext
                        .removeSpecifiedOptions.push(2 /* Status */);
                    projection
                        .propertyTypeContext
                        .removeSpecifiedOptions.push(1 /* State */);
                }
                this.onObjectQueryModified(objectQuery);
                return projection;
            };
            ObjectQueryService.prototype.createNewPredicate = function (objectQuery, parent) {
                var restriction = this.createNewEntity("ObjectQueryPredicate", {});
                this.linkRestrictionParents(restriction, objectQuery, parent);
                restriction.operatorType = 0 /* Equals */;
                restriction.rightRestrictionType = 1 /* InputParameterValue */;
                restriction.propertyType = 0 /* Property */;
                restriction.processType = null;
                restriction.processType_id = null;
                restriction.processSubType_id = null;
                restriction.stateUniqueIdentifier = null;
                restriction.statusUniqueIdentifier = null;
                restriction.restrictionType = "P";
                restriction.states = this.getStates();
                restriction.statuses = this.getStatuses();
                restriction.processTypes = this.getProcessTypes();
                restriction.processSubTypes = this.getProcessSubTypes();
                restriction.reviewConfigurations = this.getReviewConfigurations();
                restriction.reviewTypes = this.getReviewTypes();
                restriction.assignmentClaims = this.getClaims();
                this.onObjectQueryModified(objectQuery);
                return restriction;
            };
            ObjectQueryService.prototype.createNewOrGroup = function (objectQuery, parent) {
                var restriction = this.createNewEntity("ObjectQueryDisjunction", {});
                this.linkRestrictionParents(restriction, objectQuery, parent);
                restriction.restrictionType = "D";
                this.onObjectQueryModified(objectQuery);
                return restriction;
            };
            ObjectQueryService.prototype.createNewAndGroup = function (objectQuery, parent) {
                var restriction = this.createNewEntity("ObjectQueryConjunction", {});
                this.linkRestrictionParents(restriction, objectQuery, parent);
                restriction.restrictionType = "C";
                this.onObjectQueryModified(objectQuery);
                return restriction;
            };
            ObjectQueryService.prototype.createNewInputSchema = function (objectQuery) {
                var schema = this.createNewEntity("ObjectSchema", {});
                //objectQuery.myInputObjectSchema = schema;
                //objectQuery.inputObjectSchema_id = schema.id;
                schema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                schema.name = objectQuery.name + " Input";
                schema.isList = false;
                return schema;
            };
            ObjectQueryService.prototype.createProjectionSchema = function (objectQuery) {
                var schema = this.createNewEntity("ObjectSchema", {});
                //objectQuery.myProjectionObjectSchema = schema;
                //objectQuery.projectionObjectSchema_id = schema.id;
                schema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                schema.name = objectQuery.name + " Output";
                schema.isList = true;
                return schema;
            };
            ObjectQueryService.prototype.createNewInputListSchema = function (objectQuery, objectSchema, name) {
                var schema = this.createNewEntity("ObjectSchema", {});
                schema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                schema.isList = true;
                schema.name = name;
                return schema;
            };
            ObjectQueryService.prototype.createNewProjectionListSchema = function (objectQuery, objectSchema, name) {
                var schema = this.createNewEntity("ObjectSchema", {});
                schema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                schema.isList = true;
                schema.name = name;
                return schema;
            };
            ObjectQueryService.prototype.createNewSchemaProperty = function (objectSchema) {
                var property = this.createNewEntity("SchemaProperty", {});
                property.objectSchema_id = objectSchema.id;
                property.parentObjectSchema = objectSchema;
                property.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return property;
            };
            ObjectQueryService.prototype.getAllObjectQueriesForProcessConfiguration = function (id) {
                //.Left.JoinQueryOver(() => objectQuery.MyInputObjectSchema, () => inputSchema)
                //.Left.JoinQueryOver(() => inputSchema.Properties, () => inputSchemaProperty)
                //.Left.JoinQueryOver(() => inputSchemaProperty.TypeSchema, () => inputTypeSchema)
                //.Left.JoinQueryOver(() => objectQuery.MyProjectionObjectSchema, () => projectionSchema)
                //.Left.JoinQueryOver(() => projectionSchema.Properties, () => projectionSchemaProperty)
                //.Left.JoinQueryOver(() => projectionSchemaProperty.TypeSchema, () => projectionTypeSchema)
                //.Left.JoinQueryOver(() => objectQuery.Projections, () => objectQueryProjection)
                //.Left.JoinQueryOver(() => objectQueryProjection.ReportDataTreeItem, () => projectionTreeItem)
                //.Left.JoinQueryOver(() => projectionTreeItem.SchemaProperty)
                //.Left.JoinQueryOver(() => objectQuery.Restrictions)
                //.Left.JoinQueryOver(() => objectQuery.Predicates, () => objectQueryPredicate)
                //.Left.JoinQueryOver(() => objectQueryPredicate.LeftReportDataTreeItem)
                //.Left.JoinQueryOver(() => objectQueryPredicate.RightParameterTreeItem)
                //.Left.JoinQueryOver(() => objectQueryPredicate.MyObjectQuery)
                var expand = "myInputObjectSchema.properties.typeSchema, " +
                    "myProjectionObjectSchema.properties.typeSchema, " +
                    "projections.reportDataTreeItem.schemaProperty, " +
                    "restrictions, " +
                    "predicates.leftReportDataTreeItem, " +
                    "predicates.rightParameterTreeItem, " +
                    "predicates.myObjectQuery";
                var query = this.breezeModule.EntityQuery
                    .from("ObjectQueries")
                    .where("processConfiguration_id", "==", id)
                    .expand(expand);
                return this.executeQuery(query);
            };
            ObjectQueryService.prototype.getProcessLevelObjectQueries = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ObjectQueries")
                    .where("processConfiguration_id", "==", id);
                return this.executeQuery(query);
            };
            ObjectQueryService.prototype.getAllObjectQueriesForSystemLevel = function () {
                var expand = "myInputObjectSchema.properties.typeSchema, " +
                    "myProjectionObjectSchema.properties.typeSchema, " +
                    "projections.reportDataTreeItem.schemaProperty, " +
                    "restrictions, " +
                    "predicates.leftReportDataTreeItem, " +
                    "predicates.rightParameterTreeItem, " +
                    "predicates.myObjectQuery";
                var query = this.breezeModule.EntityQuery
                    .from("ObjectQueries")
                    .where("processConfiguration_id", "==", null)
                    .expand(expand);
                return this.executeQuery(query);
            };
            ObjectQueryService.prototype.getReviewConfigurations = function () {
                return Enumerable
                    .from(this.reviewConfigurations)
                    .select(function (i) { return new ObjectQueryStringTuple(i.name, i.uniqueIdentifier); })
                    .toArray();
            };
            ObjectQueryService.prototype.getReviewTypes = function () {
                var _this = this;
                var result = new Array();
                if (this.reviewConfigurations != null) {
                    for (var i = 0; i < this.reviewConfigurations.length; i++) {
                        if (this.reviewConfigurations[i].reviewTypes == null || this.reviewConfigurations[i].reviewTypes.length === 0)
                            continue;
                        for (var ii = 0; ii < this.reviewConfigurations[i].reviewTypes.length; ii++) {
                            if (Enumerable.from(result).any(function (x) { return x.value === _this.reviewConfigurations[i].reviewTypes[ii].uniqueIdentifier; }))
                                continue;
                            result.push(new ObjectQueryStringTuple("[" + this.reviewConfigurations[i].reviewTypeCodeName + "] " + this.reviewConfigurations[i].reviewTypes[ii].shortDescription, this.reviewConfigurations[i].reviewTypes[ii].uniqueIdentifier));
                        }
                    }
                }
                return result;
            };
            ObjectQueryService.prototype.getClaims = function () {
                return Enumerable
                    .from(this.claims)
                    .select(function (i) { return new ObjectQueryStringTuple(i.name, i.uniqueIdentifier); })
                    .toArray();
            };
            ObjectQueryService.prototype.getProcessTypes = function () {
                return Enumerable
                    .from(this.processTypes)
                    .select(function (i) { return new ObjectQueryStringTuple(i.name, i.id); })
                    .toArray();
            };
            ObjectQueryService.prototype.getProcessSubTypes = function () {
                return Enumerable
                    .from(this.processSubTypes)
                    .select(function (i) { return new ObjectQueryStringTuple(i.name, i.id); })
                    .toArray();
            };
            ObjectQueryService.prototype.getCustomTransformers = function () {
                var self = this;
                var d = self.qService.defer();
                self.extensibilityService.getCustomTransformers()
                    .then(function (result) {
                    d.resolve(Enumerable.from(result.extensibleComponents).where(function (i) { return i.enabled; }).toArray());
                });
                return d.promise;
            };
            ObjectQueryService.prototype.getStatuses = function () {
                return Enumerable
                    .from(this.statuses)
                    .select(function (i) { return new ObjectQueryStringTuple(i.shortDescription, i.uniqueIdentifier); })
                    .toArray();
            };
            ObjectQueryService.prototype.getStates = function () {
                var _this = this;
                var result = new Array();
                for (var i = 0; i < this.statuses.length; i++) {
                    var states = Enumerable
                        .from(this.statuses[i].states)
                        .select(function (x) { return new ObjectQueryStringTuple("[" + _this.statuses[i].shortDescription + "] " + x.shortDescription, x.uniqueIdentifier); })
                        .toArray();
                    result.addRange(states);
                }
                return result;
            };
            ObjectQueryService.prototype.loadConfig = function (id) {
                var self = this;
                var d = self.qService.defer();
                if (id == null) {
                    self.$http.get("api/ObjectQuery/ProcessStatusList").then(function (result) {
                        if (result != null && result.data != null) {
                            var statuses = result.data;
                            self.statuses = statuses;
                            self.$http.get("api/ObjectQuery/ProcessTypeList").then(function (result2) {
                                var processTypes = result2.data;
                                self.processTypes = processTypes;
                                self.$http.get("api/ObjectQuery/ReviewConfigurationList").then(function (result3) {
                                    var reviewConfigurations = result3.data;
                                    self.reviewConfigurations = reviewConfigurations;
                                    self.$http.get("api/ObjectQuery/AssignmentClaimList").then(function (result4) {
                                        var assignmentClaims = result4.data;
                                        self.claims = assignmentClaims;
                                        self.$http.get("api/ObjectQuery/ProcessSubTypeList").then(function (result5) {
                                            var processSubTypes = result5.data;
                                            self.processSubTypes = processSubTypes;
                                            d.resolve();
                                        });
                                    });
                                });
                            });
                        }
                    });
                }
                else {
                    self.$http.get("api/ObjectQuery/ProcessStatusList?processConfigurationId=" + id).then(function (result) {
                        if (result != null && result.data != null) {
                            var statuses = result.data;
                            self.statuses = statuses;
                            self.$http.get("api/ObjectQuery/ReviewConfigurationList?processConfigurationId=" + id).then(function (result2) {
                                var reviewConfigurations = result2.data;
                                self.reviewConfigurations = reviewConfigurations;
                                self.$http.get("api/ObjectQuery/AssignmentClaimList?processConfigurationId=" + id).then(function (result3) {
                                    var assignmentClaims = result3.data;
                                    self.claims = assignmentClaims;
                                    self.$http.get("api/ObjectQuery/ApiQueryList").then(function (result4) {
                                        var apiActions = result4.data;
                                        self.apiActions = apiActions;
                                        self.$http.get("api/ObjectQuery/ProcessSubTypeList?processConfigurationId=" + id).then(function (result5) {
                                            var processSubTypes = result5.data;
                                            self.processSubTypes = processSubTypes;
                                            d.resolve();
                                        });
                                    });
                                });
                            });
                        }
                    });
                }
                return d.promise;
            };
            ObjectQueryService.prototype.linkRestrictionParents = function (restriction, objectQuery, parent) {
                restriction.myObjectQuery = objectQuery;
                restriction.objectQuery_id = objectQuery.id;
                if (parent != null) {
                    restriction.myParentRestriction = parent;
                    restriction.parentRestriction_id = parent.id;
                }
            };
            return ObjectQueryService;
        }(services.DataService));
        services.ObjectQueryService = ObjectQueryService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("ObjectQueryService", ["breeze", "$q", "$http", "extensibilityService", "deleteService"]);
